/* eslint-disable complexity */
/* eslint-disable class-methods-use-this */
import React from 'react';
import store from 'Store';
import watch from 'redux-watch';
import Location from 'utils/Location';
import { Icon, Link, Text } from 'components/ui';
import keyConsts from 'utils/KeyConstants';
import analyticsUtils from 'analytics/utils';
import FrameworkUtils from 'utils/framework';
import Perf from 'utils/framework/Perf';
import userUtils from 'utils/User';
import biApi from 'services/api/beautyInsider';
import localeUtils from 'utils/LanguageLocale';
import SiteSearchEN from 'components/SiteSearch/locales/SiteSearch_en_US';
import SiteSearchFR from 'components/SiteSearch/locales/SiteSearch_fr_CA';
import JStorage from 'utils/localStorage/Search';
import Storage from 'utils/localStorage/Storage';
import searchActions from 'actions/SearchActions';
import BaseClass from 'components/BaseClass/BaseClass';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import TextInput from 'components/Inputs/TextInput/TextInput';
import TrendingSearch from 'components/SiteSearch/TrendingSearch';
import SearchItem from 'components/SiteSearch/SearchItem';
import ConstructorRecsActions from 'actions/ConstructorRecsActions';
import { getProductsFromKeyword } from 'services/api/search-n-browse/searchProductsByKeyword';
import { TestTargetReady } from 'constants/events';
import {
    radii,
    colors,
    shadows,
    forms,
    site,
    space,
    screenReaderOnlyStyle,
    mediaQueries,
    lineHeights,
    fontSizes,
    fontWeights,
    zIndices
} from 'style/config';
import { CONSTRUCTOR_PODS } from 'constants/constructorConstants';
import { SEARCH_VARIANT } from 'constants/Shared';
import Carousel from 'components/Carousel';
import ProductImage from 'components/Product/ProductImage/ProductImage';
import Empty from 'constants/empty';
import anaConsts from 'analytics/constants';
import { QUERY_PARAMS } from 'constants/Shared';
import anaUtils from 'analytics/utils';
import helpersUtils from 'utils/Helpers.js';
import urlUtils from 'utils/Url';
import javascriptUtils from 'utils/javascript';
const { buildQuery } = urlUtils;
const { buildMap } = javascriptUtils;

import Debounce from 'utils/Debounce';

import { OPEN_SPA_SEARCH_PAGE_API_START, OPEN_SPA_SEARCH_PAGE_API_LOADED } from 'constants/performance/marks';

const { updateRequestData } = ConstructorRecsActions;
const { deferTaskExecution } = helpersUtils;
const DEBOUNCE_BLUR = 200;
const SEARCH_SELECTION_TYPES = {
    MANUAL: 'manual',
    TYPEAHEAD: 'type-ahead',
    TRENDING: 'trending'
};
const SEARCH_TYPE_KEY = 'prevSearchType';
const SEARCH_TERM_KEY = 'searchTerm';
const SEARCH_PAGE_URL = '/search';

const FIVE_MINUTES_IN_MILLISECONDS = 300000;
const { StorageTypes } = Storage;
// Utils

const ZERO_STATE_SEARCH_EXPERIENCE_SIZE = 5;
const SEARCH_ICON_SIZE = 16;
const SEARCH_ICON_INDENT = space[3];
const SUGGESTIONS_CONFIG = {
    productSuggestions: 5,
    searchSuggestions: 5,
    categorySuggestions: 5
};

const ZERO_STATE_SEARCH_CONSTRUCTOR = {
    challengerOne: {
        podId: CONSTRUCTOR_PODS.TRENDING_SEARCHES,
        params: { section: 'Search Suggestions' }
    },
    challengerTwo: {
        podId: CONSTRUCTOR_PODS.TRENDING_CATEGORIES,
        params: { section: 'Categories' }
    }
};

const getText = localeUtils.getLocalisedDataFromResource(SiteSearchEN, SiteSearchFR);

const { wrapComponent } = FrameworkUtils;

class SiteSearch extends BaseClass {
    state = {
        focus: false,
        keyword: null,
        highlightedIndex: -1,
        userSearchKeyword: '',
        trendingCategories: [],
        zeroStateSearchExperience: '',
        zeroStateSearchConstructorExperience: {},
        zeroStateSearch: { sectionName: '', items: [], isCarousel: false, carouselItems: [] },
        buyItAgainItems: [],
        isBuyItAgainFetched: false
    };

    inputRef = React.createRef();
    containerRef = React.createRef();

    purchaseHistoryRequestInFlight = false;

    handleClickOutside = event => {
        if (!this.containerRef.current?.contains(event?.target)) {
            this.handleBlur();
        }
    };

    getFilteredBuyItAgainFrom = typedValue => {
        const { showSearchDropdownBuyItAgain = false } = this.props;
        const { buyItAgainItems } = this.state;
        const typedLen = typedValue.length;
        const query = typedValue.toLowerCase();

        if (!(showSearchDropdownBuyItAgain && buyItAgainItems.length && typedLen >= 3)) {
            return Empty.Array;
        }

        const matches = buyItAgainItems.filter(itm => {
            const name = (itm.productName || '').toLowerCase();
            const desc = (itm.brandDescription || '').toLowerCase();

            return name.includes(query) || desc.includes(query);
        });

        return matches.slice(0, 5);
    };
    componentDidMount() {
        const { variant = SEARCH_VARIANT.SITE } = this.props;
        const searchWatch = watch(store.getState, 'search');
        store.subscribe(
            searchWatch(data => {
                const newVal = data[variant];
                const wasFocused = this.state.focus;
                const filteredResults = newVal.results?.filter(item => !item.trendingCategories);
                const trendingCategories = newVal.results?.find(item => item.trendingCategories)?.trendingCategories || [];

                this.setState(
                    {
                        focus: newVal.focus,
                        keyword: newVal.keyword,
                        results: filteredResults,
                        trendingCategories: trendingCategories
                    },
                    () => {
                        if (!wasFocused && newVal.focus && this.inputRef && this.inputRef.current) {
                            this.inputRef.current.focus();
                        }
                    }
                );
            }),
            this
        );
        this.keyUpEvent = {
            prevSearchValue: null
        };
        // We want to be able to update/clear the search term on any SPA navigation, for this we check if the location changed.
        // This can be refactored to used the connect HOC later
        store.setAndWatch('historyLocation', this, data => {
            if (data?.historyLocation?.prevPath !== data?.historyLocation?.path) {
                const analyticCookieData = analyticsUtils.getPreviousPageData();
                const { clickedItem } = analyticCookieData;
                const clickedItemValue = analyticCookieData[SEARCH_TERM_KEY];
                const persistedSearchTerm = Storage.local.getItem(LOCAL_STORAGE.SEARCH_TERM_PERSIST);
                let userSearchKeyword = clickedItem ? clickedItemValue : persistedSearchTerm?.searchTerm;

                if (!userSearchKeyword) {
                    userSearchKeyword = '';
                }

                this.setState({ userSearchKeyword }, () => {
                    if (persistedSearchTerm) {
                        Storage.local.removeItem(LOCAL_STORAGE.SEARCH_TERM_PERSIST);
                    }
                });
            }
        });

        //Wait for new zero state search experience from test and target
        Sephora.Util.onLastLoadEvent(window, [TestTargetReady], () => {
            store.setAndWatch('testTarget', this, newOffers => {
                const zeroStateSearchExperience = newOffers.testTarget.offers?.zeroStateSearch?.experience || '';

                if (this.state.zeroStateSearchExperience !== zeroStateSearchExperience) {
                    this.setState({ zeroStateSearchExperience });
                }
            });
        });

        //Zero state search experience from constructor is available. Save to component to avoid re renders on the same experience
        store.setAndWatch('constructorRecommendations.constructorRecommendations', this, data => {
            if (this.isZeroStateSearchExperienceFromConstructor()) {
                const desiredZeroStateExperienceFromConstructor = this.getDesiredZeroStateSearchExperienceFromConstructor();
                const prevZeroStateSearchConstructorExperience = this.state.zeroStateSearchConstructorExperience;
                const currentZeroStateSearchConstructorExperience =
                    data.constructorRecommendations[desiredZeroStateExperienceFromConstructor.podId] || {};

                if (prevZeroStateSearchConstructorExperience.constructorTitle !== currentZeroStateSearchConstructorExperience.constructorTitle) {
                    this.setState({ zeroStateSearchConstructorExperience: currentZeroStateSearchConstructorExperience });
                }
            }
        });

        window.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(_, prevState) {
        this.handleZeroStateSearchExperienceChange(prevState.zeroStateSearchExperience);

        this.handleZeroStateSearchConstructorExperienceChange(prevState.zeroStateSearchConstructorExperience);

        this.displayBuyItAgainChallenger();
    }

    handleZeroStateSearchConstructorExperienceChange = prevConstructorExperience => {
        //Zero State search experience constructor data is available and is new
        if (
            this.state.zeroStateSearchExperience &&
            prevConstructorExperience.constructorTitle !== this.state.zeroStateSearchConstructorExperience.constructorTitle
        ) {
            this.addZeroStateSearchResultsForCurrentConstructorExperience();
        }
    };

    handleZeroStateSearchExperienceChange = prevExperience => {
        const displayRemainingZeroStateChallengers = Sephora.configurationSettings?.displayRemainingZeroStateChallengers;

        //Receive a new Search experience from ABTests
        if (prevExperience !== this.state.zeroStateSearchExperience) {
            //Search Experience no longer exists. Return to default state
            if (!this.state.zeroStateSearchExperience) {
                this.removeZeroStateSearchExperience();

                return;
            }

            //Experience received needs constructor information
            if (this.isZeroStateSearchExperienceFromConstructor()) {
                this.requestConstructorRecommendationForCurrentExperience();

                return;
            }

            if (this.state.zeroStateSearchExperience === 'challengerThree' && displayRemainingZeroStateChallengers) {
                this.displayZeroStateSearchChallengerThree();

                return;
            }

            if (this.state.zeroStateSearchExperience === 'challengerFour' && displayRemainingZeroStateChallengers) {
                this.displayZeroStateSearchChallengerFour();

                return;
            }

            //TODO Add Logic when experience is not from constructor Challenger 5
        }
    };

    displayZeroStateSearchChallengerThree = () => {
        const recentlyViewedItems = Storage.local.getItem('rvData');
        const carouselItems = recentlyViewedItems
            ?.map((item, index) => (
                <ProductImage
                    key={`${item.skuId}-${index}`}
                    id={item.skuId}
                    size={48}
                    onClick={() => this.handleItemClick({ value: item.productName }, item.targetUrl)}
                />
            ))
            ?.slice(0, 10);

        this.setState({
            zeroStateSearch: {
                sectionName: carouselItems?.length ? getText('continueBrowsing') : '',
                isCarousel: !!carouselItems?.length,
                carouselItems,
                items: Empty.Array
            }
        });
    };

    displayZeroStateSearchChallengerFour = () => {
        if (userUtils.isAnonymous()) {
            return;
        }

        const user = store.getState('user').user;
        const options = {
            sortBy: 'recently',
            groupBy: 'none',
            excludeSamples: true,
            excludeRewards: true,
            itemsPerPage: 10
        };

        biApi
            .getPurchaseHistory(user.profileId, options)
            .then(purchaseHistory => {
                const purchasedItems = purchaseHistory?.purchasedItems;

                if (purchasedItems.length) {
                    const carouselItems = purchasedItems
                        ?.map((item, index) => (
                            <ProductImage
                                key={`${item.sku?.skuId}-${index}`}
                                id={item.sku?.skuId}
                                size={48}
                                onClick={() => this.handleItemClick({ value: item.sku?.productName }, item.sku?.targetUrl)}
                            />
                        ))
                        ?.slice(0, 10);

                    this.setState({
                        zeroStateSearch: {
                            sectionName: carouselItems?.length ? getText('buyItAgain') : '',
                            isCarousel: !!carouselItems?.length,
                            carouselItems,
                            items: Empty.Array
                        }
                    });
                }
            })
            .catch(() => {
                this.setState({
                    zeroStateSearch: {
                        sectionName: '',
                        isCarousel: false,
                        carouselItems: Empty.Array,
                        items: Empty.Array
                    }
                });
            });
    };

    removeZeroStateSearchExperience = () => {
        this.setState({
            zeroStateSearchExperience: '',
            zeroStateSearch: { sectionName: '', items: [], isCarousel: false, carouselItems: [] },
            zeroStateSearchConstructorExperience: {}
        });

        return;
    };

    addZeroStateSearchResultsForCurrentConstructorExperience = () => {
        this.setState({
            zeroStateSearch: this.parseConstructorResponse()
        });
    };

    displayBuyItAgainChallenger = () => {
        const { showSearchDropdownBuyItAgain = false } = this.props;

        if (!showSearchDropdownBuyItAgain || this.state.isBuyItAgainFetched || userUtils.isAnonymous() || this.purchaseHistoryRequestInFlight) {
            return;
        }

        const user = store.getState('user').user;
        const options = {
            sortBy: 'recently',
            groupBy: 'none',
            excludeSamples: true,
            excludeRewards: true,
            itemsPerPage: 100
        };

        this.purchaseHistoryRequestInFlight = true;
        biApi
            .getPurchaseHistory(user.profileId, options)
            .then(purchaseHistory => {
                this.state.isBuyItAgainFetched = true;
                const purchasedItems = purchaseHistory?.purchasedItems || [];

                const displayItems = purchasedItems.map(item => {
                    const epoch = item.sku?.transactionDate;
                    const date = epoch ? new Date(epoch) : null;
                    const currentLang = localeUtils.isFRCanada() ? 'fr-FR' : 'en-US';
                    const formattedDate = date ? date.toLocaleDateString(currentLang, { month: 'short', year: 'numeric' }) : '';
                    const sku = item.sku;

                    return {
                        key: sku?.skuId,
                        skuId: sku?.skuId,
                        productId: sku?.productId,
                        productName: sku?.productName,
                        targetUrl: sku?.targetUrl,
                        imageProps: {
                            id: sku?.skuId,
                            badge: sku?.badge,
                            altText: sku?.badgeAltText,
                            size: 32,
                            skuImages: sku?.skuImages
                        },
                        description: `${sku?.variationTypeDisplayName}: ${sku?.variationValue}`,
                        haveDescription: sku?.variationTypeDisplayName && sku?.variationValue,
                        purchaseDate: `${getText('purchased')} ${formattedDate}`,
                        brandDescription: sku?.primaryProduct.brand.description
                    };
                });
                this.setState({ buyItAgainItems: displayItems });
            })
            .catch(() => {
                this.setState({ buyItAgainItems: [] });
            })
            .finally(() => {
                this.purchaseHistoryRequestInFlight = false;
            });
    };

    parseConstructorResponse = () => {
        const items = this.state.zeroStateSearchConstructorExperience.constructorRecommendations?.map(recommendation => {
            const value = recommendation.value || '';
            const term = recommendation.value || '';
            const url = recommendation.data?.url || '';

            return { value, term, url };
        });

        const reducedItems = items?.slice(0, ZERO_STATE_SEARCH_EXPERIENCE_SIZE);

        return {
            sectionName: this.state.zeroStateSearchConstructorExperience.constructorTitle || '',
            items: reducedItems || Empty.Array
        };
    };

    requestConstructorRecommendationForCurrentExperience = () => {
        const zeroStateSearchExperienceConstructor = this.getDesiredZeroStateSearchExperienceFromConstructor();
        store.dispatch(
            updateRequestData({
                podId: zeroStateSearchExperienceConstructor.podId,
                params: zeroStateSearchExperienceConstructor.params,
                isCollection: false
            })
        );
    };

    getDesiredZeroStateSearchExperienceFromConstructor = () => {
        return ZERO_STATE_SEARCH_CONSTRUCTOR[this.state.zeroStateSearchExperience];
    };

    isZeroStateSearchExperienceFromConstructor = () => {
        const zeroStateSearchExperienceConstructor = this.getDesiredZeroStateSearchExperienceFromConstructor();

        return !!zeroStateSearchExperienceConstructor;
    };

    getSearchResults = () => {
        const { variant = SEARCH_VARIANT.SITE, refinements } = this.props;

        store.dispatch(searchActions.getSearchResults(this.inputRef.current.getValue(), SUGGESTIONS_CONFIG, variant, refinements));
        anaUtils.setNextPageData({ searchVariant: variant });
    };

    handleCancelClick = e => {
        e.preventDefault();
        this.handleBlur();
    };

    setHighlightedIndex = (index, value) => {
        this.setState({ highlightedIndex: index }, () => {
            if (value) {
                this.inputRef.current.setValue(value);
            }
        });
    };

    handleFocus = () => {
        deferTaskExecution(() => {
            this.getSearchResults();
        });
    };

    handleKeyUp = e => {
        const isNotDuplicateRequest = this.inputRef.current?.getValue() !== this.keyUpEvent.prevSearchValue;

        if (isNotDuplicateRequest) {
            switch (e.key) {
                case keyConsts.UP:
                case keyConsts.DOWN:
                case keyConsts.ESC:
                case keyConsts.ENTER:
                    e.preventDefault();

                    return;
                default:
                    deferTaskExecution(() => {
                        this.getSearchResults();
                    });
            }
        } else {
            this.keyUpEvent.prevSearchValue = null;
        }
    };

    handleKeyDown = e => {
        const { highlightedIndex, results, trendingCategories, zeroStateSearch } = this.state;
        const typedValue = (this.inputRef?.current?.getValue() || '').trim();
        const isZeroStateSearch = !typedValue;

        const filteredBIA = this.getFilteredBuyItAgainFrom(typedValue);
        const biaResults = filteredBIA.map(itm => ({ value: itm.productName, url: itm.targetUrl }));

        const zeroStateItems = isZeroStateSearch ? zeroStateSearch.items : [];
        const combinedResults = [...biaResults, ...zeroStateItems, ...results, ...trendingCategories];
        let index = highlightedIndex;

        if (e.key === keyConsts.ESC) {
            this.handleClearClick();

            return;
        }

        switch (e.key) {
            case keyConsts.UP:
                if (index <= 0) {
                    index = combinedResults.length - 1;
                } else {
                    index--;
                }

                break;
            case keyConsts.DOWN:
                if (index === -1 || index >= combinedResults.length - 1) {
                    index = 0;
                } else {
                    index++;
                }

                break;
            case keyConsts.ENTER:
                this.handleSubmit(e);

                return;
            case keyConsts.TAB:
                this.handleBlur();

                return;
            default:
                return;
        }

        e.preventDefault();
        this.setHighlightedIndex(index, combinedResults[index].value);
    };

    blur = () => {
        this.setHighlightedIndex(-1);
        this.setState({ focus: false }, () => {
            const { variant = SEARCH_VARIANT.SITE } = this.props;
            store.dispatch(searchActions.focusSearchBar(false, variant));
        });
    };

    handleBlur = Debounce.debounce(this.blur, DEBOUNCE_BLUR);

    handleClearClick = () => {
        this.inputRef.current.setValue('');
        this.handleFocus();
    };

    storeSearchDataForAnalytics = (type, product = {}, dropdownItemClicked = false) => {
        const searchType = JStorage.isPreviousSearchItem(product.term || '') ? 'previous' : type;

        //Store for UFE
        const searchData = {};
        searchData[SEARCH_TYPE_KEY] = searchType;
        searchData[SEARCH_TERM_KEY] = product.term || product.value;
        searchData.clickedItem = dropdownItemClicked;
        searchData.events = [anaConsts.Event.INTERNAL_SEARCH];
        analyticsUtils.setNextPageData(searchData);
    };

    redirectUrl = (data, keyword, refinements) => {
        let redirectUrl;

        if (data.searchRedirectTarget) {
            redirectUrl = data.searchRedirectTarget.targetUrl || data.searchRedirectTarget.targetValue;
        } else {
            const queryParams = buildQuery(
                buildMap({
                    keyword: encodeURIComponent(keyword),
                    ...(refinements && { ref: refinements })
                })
            );

            redirectUrl = SEARCH_PAGE_URL + queryParams;
        }

        Location.navigateTo(null, redirectUrl);
    };

    fetchSearchDataAndRedirect = (keyword, refinements) => {
        const config = {
            cache: {
                key: keyword,
                expiry: FIVE_MINUTES_IN_MILLISECONDS,
                storageType: StorageTypes.Session
            }
        };
        performance.clearMarks(OPEN_SPA_SEARCH_PAGE_API_START);
        performance.clearMarks(OPEN_SPA_SEARCH_PAGE_API_LOADED);
        Perf.report(OPEN_SPA_SEARCH_PAGE_API_START);
        getProductsFromKeyword({
            q: keyword,
            config,
            ...(refinements && { ref: refinements })
        })
            .then(data => {
                Perf.report(OPEN_SPA_SEARCH_PAGE_API_LOADED);
                this.redirectUrl(data, keyword, refinements);
            })
            .catch(error => {
                Perf.report(OPEN_SPA_SEARCH_PAGE_API_LOADED);
                this.redirectUrl(error, keyword, refinements);
            });
    };

    handleSubmit = e => {
        this.handleBlur();
        e && e.preventDefault();

        const keyword = this.inputRef.current.getValue().trim();

        if (keyword === '') {
            return;
        }

        const product = { term: keyword };

        if (keyword) {
            Storage.local.setItem(LOCAL_STORAGE.SEARCH_TERM_PERSIST, { searchTerm: keyword });
        }

        this.storeSearchDataForAnalytics(SEARCH_SELECTION_TYPES.MANUAL, product, false);
        JStorage.setSearchTermStorageItem(product.term);
        this.fetchSearchDataAndRedirect(keyword, this.props.refinements);
    };

    /**
     * This was isolated for testing proposes
     */
    processURLRedirect = (product, keyword) => {
        const { deliveryOption, refinements } = this.props;
        let url;

        if (keyword) {
            JStorage.setSearchTermStorageItem(keyword);
        }

        if (product.productId) {
            url = '/product/' + product.productId;

            const queryParams = buildQuery(
                buildMap({
                    ...(keyword && { keyword: encodeURIComponent(keyword) }),
                    ...(deliveryOption && { [QUERY_PARAMS.DELIVERY_OPTION]: deliveryOption })
                })
            );

            url = url + queryParams;

            JStorage.setSearchTermStorageItem(product.value);
            Location.navigateTo(null, url);
        } else if (product.term) {
            JStorage.setSearchTermStorageItem(product.term);
            this.fetchSearchDataAndRedirect(product.term, refinements);
        }
    };

    handleItemClick = (product, url) => {
        this.handleBlur();
        this.storeSearchDataForAnalytics(url ? SEARCH_SELECTION_TYPES.TRENDING : SEARCH_SELECTION_TYPES.TYPEAHEAD, product, true);

        if (url) {
            Location.navigateTo(null, url);
        }

        this.inputRef.current.setValue(product.value);
        this.processURLRedirect(product, product.term);
    };

    /**
     * Highlight part of the string in search results list,
     * if it's presented.
     */
    highlight = (string, substring) => {
        if (substring) {
            const reg = new RegExp(substring.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');

            return string.replace(reg, function (str) {
                return '<b>' + str + '</b>';
            });
        } else {
            return string;
        }
    };

    render() {
        const {
            focus, highlightedIndex, results, trendingCategories, zeroStateSearch
        } = this.state;
        const { id = 'site_search', placeholder = '', showSearchDropdownBuyItAgain = false } = this.props;

        const hasResults = !!(results && results.length);
        const typedValue = (this.inputRef?.current?.getValue() || '').trim();
        const typedLen = typedValue.length;
        const isZeroStateSearch = !typedValue;
        const filteredBIA = this.getFilteredBuyItAgainFrom(typedValue);
        const showBIA = filteredBIA.length > 0 && typedLen >= 3;
        const buyItAgainCount = filteredBIA.length;
        const zeroStateSearchExperienceCount = isZeroStateSearch && !!this.state.zeroStateSearchExperience ? ZERO_STATE_SEARCH_EXPERIENCE_SIZE : 0;
        const preResultsOffset = buyItAgainCount + zeroStateSearchExperienceCount;

        return (
            <div
                css={[styles.root, focus && styles.rootOpen]}
                ref={this.containerRef}
            >
                <form
                    id={id}
                    role='search'
                    onSubmit={e => this.handleSubmit(e)}
                    css={styles.form}
                    data-cnstrc-search-form
                >
                    <label
                        htmlFor={`${id}_input`}
                        id={`${id}_label`}
                        css={screenReaderOnlyStyle}
                        children={placeholder || getText('search')}
                    />
                    <div
                        css={styles.wrapper}
                        role='combobox'
                        aria-expanded={hasResults || showBIA}
                        aria-owns={`${id}_listbox`}
                        aria-haspopup='listbox'
                        id={`${id}_combobox`}
                    >
                        <TextInput
                            type='search'
                            autoOff={true}
                            name='keyword'
                            aria-autocomplete='list'
                            aria-controls={`${id}_listbox`}
                            aria-activedescendant={highlightedIndex > -1 ? `${id}_result${highlightedIndex}` : null}
                            id={`${id}_input`}
                            maxLength={70}
                            placeholder={placeholder || getText('search')}
                            ref={this.inputRef}
                            isSmall={true}
                            indent={focus || SEARCH_ICON_SIZE + SEARCH_ICON_INDENT + 6}
                            marginBottom={null}
                            contentAfter={
                                focus &&
                                this.inputRef.current &&
                                this.inputRef.current.getValue() !== '' && (
                                    <button
                                        data-at={Sephora.debug.dataAt('search_clear_btn')}
                                        type='button'
                                        aria-label={getText('clearInputAriaLabel')}
                                        css={styles.clearButton}
                                        onClick={this.handleClearClick}
                                    >
                                        <Icon
                                            name='x'
                                            size={8}
                                        />
                                    </button>
                                )
                            }
                            data-at={Sephora.debug.dataAt(id)}
                            value={
                                this.state.userSearchKeyword !== undefined || this.state.userSearchKeyword !== null
                                    ? this.state.userSearchKeyword
                                    : this.inputRef.current && this.inputRef.current.getValue()
                            }
                            onFocus={this.handleFocus}
                            onKeyUp={this.handleKeyUp}
                            onKeyDown={this.handleKeyDown}
                            customStyle={styles.boldSearchBar}
                            data-cnstrc-search-input
                        />
                        <Icon
                            data-at={Sephora.debug.dataAt('search_icon')}
                            name='search'
                            size={SEARCH_ICON_SIZE}
                            color={colors.black}
                            css={styles.searchIcon}
                            style={focus ? { display: 'none' } : null}
                        />
                    </div>
                    {focus && (
                        <Link
                            data-at={Sephora.debug.dataAt('search_cancel_btn')}
                            color='blue'
                            paddingLeft={3}
                            paddingY={2}
                            onClick={this.handleCancelClick}
                            display={[null, 'none']}
                            children={getText('cancel')}
                        />
                    )}
                    <ul
                        aria-labelledby={`${id}_label`}
                        role='listbox'
                        id={`${id}_listbox`}
                        onMouseLeave={() => this.setHighlightedIndex(-1)}
                        css={[
                            styles.results,
                            (focus && (hasResults || showBIA)) || {
                                display: 'none'
                            }
                        ]}
                        data-cnstrc-autosuggest
                    >
                        {showSearchDropdownBuyItAgain && filteredBIA.length > 0 && typedLen >= 3 && (
                            <>
                                <li css={styles.buyItAgainHeader}>{getText('buyItAgain').toUpperCase()}</li>
                                {filteredBIA.map((itm, idx) => {
                                    const globalIndex = idx;
                                    const isActive = globalIndex === highlightedIndex;

                                    return (
                                        <li
                                            key={itm.key}
                                            css={[styles.result, styles.buyItAgainResult, isActive && styles.buyItAgainResultActive]}
                                            id={`site_search_result_bia_${idx}`}
                                            role='option'
                                            aria-selected={isActive}
                                            onMouseEnter={() => this.setHighlightedIndex(globalIndex)}
                                            onClick={() => this.handleItemClick({ value: itm.productName }, itm.targetUrl)}
                                        >
                                            <ProductImage
                                                key={`${itm.skuId}-${idx}`}
                                                id={itm.skuId}
                                                size={32}
                                            />
                                            <div css={styles.buyItAgainItemContent}>
                                                <Text css={styles.buyItAgainItemDate}>{itm.purchaseDate}</Text>
                                                {itm.productName && <Text>{itm.productName}</Text>}
                                                {itm.haveDescription && <Text css={styles.buyItAgainItemDescription}>{itm.description}</Text>}
                                            </div>
                                        </li>
                                    );
                                })}
                            </>
                        )}

                        {isZeroStateSearch && (
                            <>
                                {zeroStateSearch.sectionName && (!!zeroStateSearch.items.length || !!zeroStateSearch.carouselItems.length) && (
                                    <SearchItem sectionTitle={zeroStateSearch.sectionName} />
                                )}
                                {zeroStateSearch.items?.map((item, index) =>
                                    !item.value && !item.term ? null : (
                                        <SearchItem
                                            iconPath='/img/ufe/icons/trending.svg'
                                            index={index + buyItAgainCount}
                                            isActive={index + buyItAgainCount === highlightedIndex}
                                            value={item.value}
                                            onMouseEnter={() => this.setHighlightedIndex(index + buyItAgainCount)}
                                            handleItemClick={() => this.handleItemClick(item, item.url)}
                                            sectionTitle={item.sectionTitle}
                                        />
                                    )
                                )}
                                {zeroStateSearch.isCarousel && (
                                    <li css={styles.carouselContainer}>
                                        <Carousel
                                            id={'1e22ss'}
                                            gap={16}
                                            itemWidth={48}
                                            items={zeroStateSearch.carouselItems}
                                            isLoading={!focus}
                                            css={styles.carouselContainer}
                                        />
                                    </li>
                                )}
                                <SearchItem sectionTitle={getText('previousSearches')} />
                            </>
                        )}
                        {hasResults && (
                            <>
                                {results.map((result, index) => {
                                    const combinedIndex = preResultsOffset + index;
                                    const isActive = combinedIndex === highlightedIndex;
                                    const getSectionLabel = () => {
                                        if (index === 0 && !isZeroStateSearch) {
                                            return getText('searchSuggestions');
                                        } else if (index === SUGGESTIONS_CONFIG.searchSuggestions && !isZeroStateSearch) {
                                            return getText('productSuggestions');
                                        }

                                        return null;
                                    };
                                    const insertSectionLabel = getSectionLabel();

                                    return (
                                        <>
                                            {insertSectionLabel && <SearchItem sectionTitle={insertSectionLabel} />}
                                            <SearchItem
                                                index={combinedIndex}
                                                isActive={isActive}
                                                value={this.highlight(result.value, this.state.keyword)}
                                                productId={result.productId}
                                                defaultSku={result.defaultSku}
                                                onMouseEnter={() => this.setHighlightedIndex(combinedIndex)}
                                                handleItemClick={() => this.handleItemClick(result)}
                                                sectionLabel={
                                                    result.productId || result.defaultSku
                                                        ? getText('productSuggestions')
                                                        : getText('searchSuggestions')
                                                }
                                                result={result}
                                            />
                                        </>
                                    );
                                })}
                                <TrendingSearch
                                    styles={styles}
                                    results={results}
                                    highlightedIndex={highlightedIndex}
                                    setHighlightedIndex={this.setHighlightedIndex}
                                    handleItemClick={this.handleItemClick}
                                    highlight={this.highlight}
                                    inputRef={this.inputRef}
                                    section={getText('trendingCategories')}
                                    trendingCategories={trendingCategories}
                                    zeroStateSearchCount={preResultsOffset}
                                />
                            </>
                        )}
                    </ul>
                </form>
            </div>
        );
    }
}

const styles = {
    root: {
        position: 'relative',
        color: colors.black
    },
    rootOpen: {
        zIndex: zIndices.header,
        [mediaQueries.xsMax]: {
            position: 'fixed',
            inset: 0,
            paddingTop: (site.headerHeight - forms.HEIGHT_SM) / 2,
            paddingLeft: space.container,
            paddingRight: space.container,
            backgroundColor: colors.white
        }
    },
    form: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    },
    wrapper: {
        position: 'relative',
        flex: 1
    },
    boldSearchBar: {
        innerWrap: [
            {
                borderColor: colors.black,
                height: forms.SEARCH_BAR_HEIGHT,
                [mediaQueries.sm]: {
                    height: forms.SEARCH_BAR_HEIGHT_SM
                }
            }
        ]
    },
    results: {
        position: 'absolute',
        backgroundColor: colors.white,
        top: '100%',
        left: 0,
        width: '100%',
        paddingTop: space[2],
        paddingBottom: space[2],
        cursor: 'default',
        WebkitUserSelect: 'none',
        userSelect: 'none',
        [mediaQueries.sm]: {
            width: 'auto',
            minWidth: '100%',
            boxShadow: shadows.light,
            whiteSpace: 'nowrap',
            borderRadius: radii[3]
        }
    },
    result: {
        display: 'flex',
        alignItems: 'center',
        minWidth: '100%',
        paddingTop: space[2],
        paddingBottom: space[2],
        lineHeight: lineHeights.tight,
        [mediaQueries.xsMax]: {
            marginLeft: -space.container,
            marginRight: -space.container,
            paddingLeft: space.container,
            paddingRight: space.container
        },
        [mediaQueries.sm]: {
            paddingLeft: space[4],
            paddingRight: space[4]
        }
    },
    resultHover: {
        backgroundColor: colors.nearWhite
    },
    resultHeader: {
        color: colors.gray
    },
    clearButton: {
        color: colors.white,
        backgroundColor: colors.gray,
        lineHeight: 0,
        borderRadius: 99999,
        width: 16,
        height: 16,
        textAlign: 'center',
        marginRight: space[2],
        alignSelf: 'center',
        '.no-touch &:hover': {
            backgroundColor: colors.black
        }
    },
    searchIcon: {
        position: 'absolute',
        top: (forms.SEARCH_BAR_HEIGHT - SEARCH_ICON_SIZE) / 2,
        [mediaQueries.sm]: {
            top: (forms.SEARCH_BAR_HEIGHT_SM - SEARCH_ICON_SIZE) / 2
        },
        left: SEARCH_ICON_INDENT,
        pointerEvents: 'none'
    },
    carouselContainer: {
        maxWidth: 454,
        [mediaQueries.xsMax]: {
            marginLeft: -space.container,
            marginRight: -space.container,
            paddingLeft: space.container,
            paddingRight: space.container
        },
        [mediaQueries.sm]: {
            paddingLeft: space[4],
            paddingRight: space[4]
        }
    },
    buyItAgainHeader: {
        margin: `${space[2]}px ${space[4]}px`,
        padding: `0px ${space[2]}px`,
        backgroundColor: colors.lightBlue,
        borderRadius: radii[2],
        display: 'inline-block',
        fontSize: fontSizes.xs,
        textAlign: 'center',
        fontWeight: fontWeights.bold,
        [mediaQueries.xsMax]: {
            marginLeft: 0
        }
    },
    buyItAgainResult: {
        cursor: 'pointer'
    },
    buyItAgainResultActive: {
        backgroundColor: colors.nearWhite
    },
    buyItAgainItemContent: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: space[4],
        width: '100%'
    },
    buyItAgainItemDate: {
        color: colors.gray,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.bold
    },
    buyItAgainItemDescription: {
        color: colors.gray,
        fontSize: fontSizes.sm
    }
};

export default wrapComponent(SiteSearch, 'SiteSearch', true);
